'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _SagaKit$sagaCreator;

var _reduxSagaKit = require('redux-saga-kit');

var SagaKit = _interopRequireWildcard(_reduxSagaKit);

var _effects = require('redux-saga/effects');

var _FedopsActions = require('../actions/FedopsActions');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var appLoaded = function appLoaded(_ref) {
    var fedopsLogger = _ref.fedopsLogger;
    return (/*#__PURE__*/_regenerator2.default.mark(function _callee() {
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.next = 2;
                            return (0, _effects.call)(safeAppLoaded, fedopsLogger);

                        case 2:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this);
        })
    );
};

var interactionStart = function interactionStart(_ref2) {
    var fedopsLogger = _ref2.fedopsLogger,
        fedopsJson = _ref2.fedopsJson;
    return (/*#__PURE__*/_regenerator2.default.mark(function _callee2(_ref3) {
            var payload = _ref3.payload;

            var name, _payload$options, options;

            return _regenerator2.default.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            name = payload.name, _payload$options = payload.options, options = _payload$options === undefined ? {} : _payload$options;

                            if (!fedopsJson.interactions[name]) {
                                _context2.next = 6;
                                break;
                            }

                            _context2.next = 4;
                            return (0, _effects.call)(safeInteractionStart({ fedopsLogger: fedopsLogger }), name, options);

                        case 4:
                            _context2.next = 7;
                            break;

                        case 6:
                            console.warn('[Fedops Saga - interaction started]: interaction "' + name + '" is not defined in fedops.json.');

                        case 7:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, this);
        })
    );
};

var interactionEnd = function interactionEnd(_ref4) {
    var fedopsLogger = _ref4.fedopsLogger,
        fedopsJson = _ref4.fedopsJson;
    return (/*#__PURE__*/_regenerator2.default.mark(function _callee3(_ref5) {
            var payload = _ref5.payload;
            var name;
            return _regenerator2.default.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            name = payload.name;

                            if (!fedopsJson.interactions[name]) {
                                _context3.next = 6;
                                break;
                            }

                            _context3.next = 4;
                            return (0, _effects.call)(safeInteractionEnd({ fedopsLogger: fedopsLogger }), name);

                        case 4:
                            _context3.next = 7;
                            break;

                        case 6:
                            console.warn('[Fedops Saga - interaction ended]: interaction "' + name + '" is not defined in fedops.json.');

                        case 7:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, this);
        })
    );
};

var safeAppLoaded = function safeAppLoaded(fedopsLogger) {
    try {
        fedopsLogger.appLoaded();
    } catch (e) {
        console.warn('[Fedops Saga - app loaded]: Exception caught', e);
    }
};

var safeInteractionStart = function safeInteractionStart(_ref6) {
    var fedopsLogger = _ref6.fedopsLogger;
    return function (name, options) {
        try {
            fedopsLogger.interactionStarted(name, options);
        } catch (e) {
            console.warn('[Fedops Saga - interaction ended]: Exception caught', e);
        }
    };
};

var safeInteractionEnd = function safeInteractionEnd(_ref7) {
    var fedopsLogger = _ref7.fedopsLogger;
    return function (name) {
        try {
            fedopsLogger.interactionEnded(name);
        } catch (e) {
            console.warn('[Fedops Saga - interaction ended]: Exception caught', e);
        }
    };
};

exports.default = SagaKit.sagaCreator((_SagaKit$sagaCreator = {}, (0, _defineProperty3.default)(_SagaKit$sagaCreator, _FedopsActions.types.APP_LOADED, { handler: appLoaded }), (0, _defineProperty3.default)(_SagaKit$sagaCreator, _FedopsActions.types.INTERACTION_START, { handler: interactionStart }), (0, _defineProperty3.default)(_SagaKit$sagaCreator, _FedopsActions.types.INTERACTION_END, { handler: interactionEnd }), _SagaKit$sagaCreator));


//////////////////
// WEBPACK FOOTER
// ../node_modules/@wix/restaurants-redux/dist/sagas/FedopsSaga.js
// module id = 1034
// module chunks = 0